<template>
  <div class="base_color">
    <div id="container">

      <div class="crossBox"><van-icon @click="close" class="cross" name="cross" /></div>
      <div class="clause">
        <p style=" font-weight: bold; font-size: 16px;text-align:center">
          资讯服务
        </p>
        <p class="distance_50">
          为便利申请人了解浦发银行各项金融服务和产品，申请人自愿同意接受浦发银行通过短信、电话等方式免费向申请人发送相关金融服务和产品的资讯。
        </p>
        <p class="distance_50">
          申请人同意接受本项服务后，仍可通过浦发银行客服热线95528、信息推送渠道指定方式或手机银行进行退订，不再接收上述资讯。
        </p>
        <p class="distance_50">
          申请人如对本服务存在疑问、投诉或建议，可拨打浦发银行电话95528、或登录官方网站（www.spdb.com.cn）、或通过手机银行APP、或通过浦发银行各营业网点咨询或反映。受理申请人的问题后，我行将在15日内给予答复。  
        </p>
        
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'informationAgreement',
  data() {
    return {};
  },
  props: {
    hidePopup: {
      type: Function,
      default: null,
    },
  },
  methods: {
    close() {
      this.hidePopup();
    },
  },
};
</script>
<style scoped>
.base_color{
  width: 100%;
  height: 100%;
}
.crossBox{
  text-align: right;
}
.cross{
  font-size: 20px;
}
#container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.clause{
  flex: 1;
  overflow: auto;
  background: #fff;
  background-size: contain;
}
* {
  /* width: 90%; */
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-size: 12px;
}
body {
  font-family: '微软雅黑';
}
.distance {
  text-align: left;

  /* margin-left: 10px; */
}
.distance_50 {
  letter-spacing: 0;
  text-align: left;
  text-indent: 24px;
}
.distance_80 {
  text-align: left;

  /* margin-left: 10px; */
}
p {
  margin-bottom: 8px;
}
#close {
  position: fixed;
  top: 0;
  left: 0;
  box-sizing: border-box;
  width: 100%;
  height: 30px;
  padding-right: 10px;
  color: white;
  font-size: 20px;
  line-height: 30px;
  text-align: right;
  background: #3d4145;
}
.table{
  margin: 20px 10px;
}
</style>
